export const AUTOJERRY_BASE_URL = 'https://autojerry.fi';

export const AUTOJERRY_COMPANY_ID = 8447;

export const AUTOJERRY_EMBED_URL = `${AUTOJERRY_BASE_URL}/arvostelut/upotus/${AUTOJERRY_COMPANY_ID}/`;

export const AUTOJERRY_FETCH_TIMEOUT_MS = 10_000;

export const AUTOJERRY_API_CACHE_CONTROL = 'public, s-maxage=3600, stale-while-revalidate=86400';

export const AUTOJERRY_DEV_CACHE_CONTROL = 'public, max-age=3600';
